/* eslint-disable enforce-ids-in-jsx/unique-ids */
import React, { useCallback, useMemo, useState } from 'react'
import styled from 'styled-components'

import Button from 'components/lib/DesignSystem/Button'
import { ArrowBack } from 'components/lib/DesignSystem/Icons'

function MultiStepForm({
  steps,
  values = {},
  onSubmit,
  validators = [],
  nextButtonText = 'next',
  previousButtonText = 'back',
  submitButtonText = 'submit',
  id = '',
  className,
  header,
  validationSchemes,
  loader,
}) {
  const [step, setStep] = useState(0)

  const isValidStep = useMemo(
    () =>
      Object.keys(validationSchemes[step]).filter((key) => validators[step](key, values[key]))
        .length,
    [validationSchemes, validators, step, values]
  )

  const nextStep = useCallback(() => {
    setStep((currStep) => currStep + 1)
  }, [])

  const prevStep = useCallback(() => {
    setStep((currStep) => currStep - 1)
  }, [])

  if (!steps) {
    return null
  }

  return (
    <form id={id} className={className} onSubmit={(e) => e.preventDefault()}>
      {header ? <header>{header}</header> : null}

      <div className="step">{steps[step]}</div>

      <footer>
        <div className="steps_count">{`${step + 1}/${steps.length}`}</div>
        <div
          className="steps_buttons"
          style={{ justifyContent: step !== 0 ? 'space-between' : 'flex-end' }}
        >
          {step !== 0 ? (
            <Button
              LeftIcon={ArrowBack}
              styleType="tertiary"
              onClick={prevStep}
              text={previousButtonText}
              id={`${id}_Previous_button`}
            />
          ) : null}
          <Button
            loader={loader}
            text={step + 1 === steps.length ? submitButtonText : nextButtonText}
            id={`${id}_${step + 1 === steps.length ? 'Submit_button' : 'Next_Button'}`}
            onClick={step + 1 === steps.length ? onSubmit : nextStep}
            disabled={isValidStep}
          />
        </div>
      </footer>
    </form>
  )
}

export default styled(MultiStepForm)`
  height: 100%;
  padding: 30px;
  display: flex;
  flex-direction: column;
  header {
    margin-bottom: 16px;
  }
  .step {
    flex: 1;
  }
  footer {
    margin: 0;
    position: relative;
    & > .steps_count {
      position: absolute;
      bottom: 50%;
      left: 50%;
      transform: translate(-50%, 50%);
    }
    .steps_buttons {
      display: flex;
      & > button {
        text-transform: capitalize;
      }
    }
  }
`
